export default __webpack_public_path__ + "static/media/about-1.79b5ac2c.png";